export enum PhoneType {
    Work = 'phone.work',
    Home = 'phone.home',
    Mobile = 'phone.mobile',
    Fax = 'phone.fax',
}
